import React from 'react';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import IsActive from '../../../../common/cells/IsActive';
import { FreeOfChargeCategoryPropType } from '../proptypes/FreeOfChargeCategoryProptypes';

const FreeOfChargeCategoryBasicInformationResouce = ({
  freeOfChargeCategory,
}) => {
  const { name, description, active } = freeOfChargeCategory || {};

  return (
    <>
      <ResourceProperty label="Nombre:">{name || '-'}</ResourceProperty>
      <ResourceProperty label="Descripción:">
        {description || '-'}
      </ResourceProperty>
      <ResourceProperty label="active:">
        <IsActive value={active} />
      </ResourceProperty>
    </>
  );
};

FreeOfChargeCategoryBasicInformationResouce.propTypes = {
  freeOfChargeCategory: FreeOfChargeCategoryPropType,
};

FreeOfChargeCategoryBasicInformationResouce.defaultProps = {
  freeOfChargeCategory: null,
};

export default FreeOfChargeCategoryBasicInformationResouce;
